import { ReactNode } from "react";

// 16:9 black video frame (the padding-bottom trick keeps the aspect ratio).
// Shared by the player modal and the public shared-clip page.
export default function VideoFrame({ children }: { children: ReactNode }) {
  return (
    <div className="relative pb-[56.25%] h-0 bg-black rounded-xl shadow-2xl overflow-hidden">
      {children}
    </div>
  );
}
